import * as React from 'react';

import classnames from 'classnames';

import type {LeadStatus} from 'nutshell-graphql-types';
import type {Lead as LeadFragment} from 'nutshell-graphql-types';

import styles from './lead-value.module.css';

type Props = {
    status: LeadStatus;
    isHot: boolean;
    value: LeadFragment['value'];
};

export function LeadValue(props: Props) {
    const styleName = classnames(styles['lead-value'], {
        [styles.won]: props.status === 'WON',
        [styles.open]: props.status === 'OPEN',
        [styles.hot]: props.isHot,
    });

    return (
        <div className={styleName}>
            {props.value ? <span>{props.value.formatted}</span> : undefined}
        </div>
    );
}
